<template>
    <article class="preview-card-container">
        <h3 style="margin-left: 10px">
            原始圖卡
        </h3>
        <div 
            class="card-container"
            ref="card_ele"
        >
            <div
                class="card" 
                :style="{
                    overflow:'hidden',
                    display:'flex',
                    flexDirection:'column',
                    width:'100%',
                    minWidth:'340px',
                    boxShadow:'rgba(100, 100, 111, 0.2) 0px 7px 29px 0px'						
                }"
            >
                <Timer
                    :setting="timer_setting"
                    :activate="this.oldSettingData !== null ? this.oldSettingData.is_countdown : marketing_card.is_auto_coupon"
                />

                <article class="card-content"
                    v-bind:style="{
                        display: 'flex',
                        flexDirection: 'row',
                        overflow: 'hidden',
                        maxHeight: '100px'								
                    }"
                >

                    <img 
                        class="card-img"
                        v-bind:src="marketing_card_setting.img_url !== '' ? marketing_card_setting.img_url : card_img_src"
                        v-bind:style="{
                            minWidth: '100px',
                            maxWidth: '100px',
                            width: '100px',
                            height: '100px',
                            minHeight: '100px',
                            maxHeight: '100px',
                            backgroundColor: marketing_card_setting.card_img_bg_color,	
                        }"
                        ref="img"
                    />
                    
                    <section 
                        class="card-text"
                        v-bind:style="{
                            width: '100%'		
                        }"
                    >
                        <div class="card-header" 
                            v-bind:style="{
                                minHeight: '1em',
                                backgroundColor: marketing_card_setting.card_title_bg_color,
                                color: marketing_card_setting.card_title_color,
                                position: 'relative'
                                
                            }"
                        >
                            <h3
                                v-bind:style="{
                                    textAlign: marketing_card_setting.card_title_align,
                                    paddingLeft: '12px',
                                    paddingRight: '15px',
                                    paddingTop: '3px',
                                    paddingBottom: '3px',
                                    fontSize: '20px',
                                    margin: '0px',
                                    fontWeight: 'bold',
                                    lineHeight: 'normal'
                                }"
                            >
                            {{ marketing_card_setting.card_title }}
                            </h3>
                            <i 
                                name="close_card_btn"
                                v-bind:style="{
                                    position: 'absolute',
                                    color: marketing_card_setting.card_close_color,
                                    fontStyle: 'normal',
                                    right: '12px',
                                    top: '4px',
                                    cursor: 'pointer'
                                }" 
                            >
                                ✕
                            </i>
                        </div>
                        <section
                            v-bind:style="{
                                paddingTop: '3px',
                                lineHeight:1.2,
                                paddingLeft: '12px',
                                height:'100%',
                                backgroundColor: marketing_card_setting.card_content_bg_color,
                                fontSize:'16px',
                            }"
                            v-html="marketing_card_setting.tinymce_content"
                            class="card-text-content"
                        >	
                        </section>
                    </section>
                </article>
                <article class="card-footer"
                    v-bind:style="{
                        minHeight: '1em',
                        backgroundColor: marketing_card_setting.card_hint_bg_color,
                    }"
                >
                    <h3
                        v-bind:style="{
                            textAlign: marketing_card_setting.card_hint_align,
                            margin: '0px',
                            fontSize: '18px',
                            fontWeight: 'bold',
                            letterSpacing: '3px',
                            whiteSpace: 'no',
                            color: marketing_card_setting.card_hint_color,
                            padding: '5px',
                            lineHeight: 'normal'
                        }"							
                    >
                    {{marketing_card_setting.card_hint}}
                    </h3>
                </article>
            </div>    
        </div>
    </article>
</template>

<script>

// 倒數計時器
import Timer from './CardComponents/Timer.vue'

// 引入 mapState 函數，用於簡化 computed 屬性的設定
import { mapState, mapGetters } from 'vuex';

export default {
    props: {
        timeLineMode: String,
        loadOldSettingData: Boolean,
    },
    name : "OriginalCard",
    components: {
        Timer
    },
    data() {
        return {
            /* tinymce輸入內容的變數 */
      	    tinymce_content: '<p>圖卡內文</p>',

            /* 是否自動帶入優惠代碼 */
      	    // isAutoCoupon: false,

            /* 圖卡叉叉顏色 */
      	    card_close_color: '#000',

            /* 桌機原始圖卡向上位移 */
            card_desktop_mg_bottom: '10',

            /* 桌機原始圖卡向左位移 */
            card_desktop_mg_right: '10',

            /* 原始圖卡圖片 */
            // card_img_src: 'https://pic.optimize99.com/api/img/_/cmp/1690251392463.jpg',
            card_img_src: '~/frontend_optimize99/user/public/logo.png',
            

            /* 原始圖卡圖片背景顏色 */
            // card_img_bg_color: '',

            /* 原始圖卡標題設定 */
            card_title: '圖卡標題',
            card_title_color: '#000',
            card_title_bg_color: '#ffffff',
            card_title_align: 'left',

            /* 原始圖卡行銷文字設定 */
            card_hint:'行銷文字',
            card_hint_color: '#000',
            card_hint_bg_color: '#ffffff',
            card_hint_align:'center',

            /* 原始圖卡內文設定 */
            card_content_bg_color: '#ffffff',

            // 圖片網址
		    img_url: '',

            /* 倒數計時說明文字 */
            count_down_text: "限時倒數",
            count_down_text_bg_color: "#ffb3be",
            count_down_text_color: "#ff0f0f",

            // 倒數計時結束後要顯示的文字內容
            timer_off_text: '活動已結束',

            // 倒數計時結束後要顯示的文字顏色
            timer_off_text_color: "#ff0f0f",

            
            //結尾
            count_down_text_end: "！",
            count_down_text_end_color: "#ff0f0f",

            count_down_d_text: "日",
            count_down_d_text_color: "#FFF",
            count_down_d_value_color: "#FFF",

            count_down_h_text: "小時",
            count_down_h_text_color: "#FFF",
            count_down_h_value_color: "#FFF",

            count_down_m_text: "分",
            count_down_m_text_color: "#FFF",
            count_down_m_value_color: "#FFF",

            count_down_s_text: "秒",
            count_down_s_text_color: "#FFF",
            count_down_s_value_color: "#FFF",

            marketing_card_setting: null,
            parseKey: {
                "活動預熱" : 'warmUpCardSetting',
                "活動進行" : 'activityCardSetting',
                "活動結束" : 'endUpCardSetting'
            }
        }
    },
    mounted() {
        console.log("yo Original Card");
        // this.card_img_src = this.loggedInfo?.['default_value']?.['containersValue']?.[this.selectedContainer?.['name']]?.['card_image'] || ""
        // if (this.card_img_src !== "") {
        //     this.$refs.img.src = this.card_img_src 
        // }
    },
    computed: {
        timer_setting(){
    		let setting = {
    			"font_size": "18px",
    			"type": "original",
    			"end_at": this.marketing_card.end_at ? this.$utils.parseDateFormat(this.marketing_card.end_at) : "",
    			"bg_color": this.marketing_card.count_down_text_bg_color, 

    			"description": this.marketing_card.count_down_text,
    			"description_color": this.marketing_card.count_down_text_color,

    			"description_end": this.marketing_card.count_down_text_end,
    			"description_end_color": this.marketing_card.count_down_text_end_color,

    			"d_text": this.marketing_card.count_down_d_text,
    			"d_text_color": this.marketing_card.count_down_d_text_color,
    			"d_value_color": this.marketing_card.count_down_d_value_color,

    			"h_text": this.marketing_card.count_down_h_text,
    			"h_text_color": this.marketing_card.count_down_h_text_color,
    			"h_value_color": this.marketing_card.count_down_h_value_color,    			
    			"m_text": this.marketing_card.count_down_m_text,
    			"m_text_color": this.marketing_card.count_down_m_text_color,
    			"m_value_color": this.marketing_card.count_down_m_value_color,     			
    			"s_text": this.marketing_card.count_down_s_text,
    			"s_text_color": this.marketing_card.count_down_s_text_color,
    			"s_value_color": this.marketing_card.count_down_s_value_color,
				"repeat_day": Number(this.marketing_card.repeat_day),
				"timer_off_text": this.marketing_card.timer_off_text,
				"timer_off_text_color": this.marketing_card.timer_off_text_color,
				"start_at": this.marketing_card.start_at ? this.$utils.parseDateFormat(this.marketing_card.start_at) : "",
				"campaign_start_at": this.marketing_card.campaign_start_at ? this.$utils.parseDateFormat(this.marketing_card.campaign_start_at) : "",
				"campaign_end_at": this.marketing_card.campaign_end_at ? this.$utils.parseDateFormat(this.marketing_card.campaign_end_at) : ""
    		}
			
    		return setting
    	},
        ...mapState(['is_auto_coupon','marketing_card',]),
        ...mapGetters(["selectedContainer","loggedInfo","selectedAdmin","selectedOrg","selectedMarketingCardContainer","oldSettingData",'warmUpCardSetting','activityCardSetting','endUpCardSetting'])
    },
    methods: {
        emitInnerHTML() {
            const CardInnerHTML = this.$refs.card_ele.innerHTML;
            // console.log(CardInnerHTML);
            this.$emit('card-innerhtml', CardInnerHTML);
        },
    },
    created() {
        
    },

    watch: {
        is_auto_coupon(newValue, oldValue) {
            console.log("newValue", newValue);
            console.log("oldValue", oldValue);
        },
        marketing_card: {
            handler: function(newValue) {
                // if (newValue) {
                    // let that = this 
                    console.log(newValue);
                    this.marketing_card_setting = newValue
                // }
            },
            deep: true,
            immediate: true
        },
        'marketing_card.get_ele_innerHTML': {
            handler: function(newValue) {
                console.log('marketing_card.get_ele_innerHTML');
                console.log(newValue);
                if (newValue) {
                    // this.changeStatus('marketing_card','mini_card_ele', this.$refs.mini_card_ele.innerHTML)
                    this.$nextTick(() => {
                        this.emitInnerHTML()   
                    })
                }
                // let that = this
                // that.marketing_card_setting = newValue 
            },
            deep: true,
            immediate: true
        },
        'marketing_card.is_auto_coupon': {
            handler: function(newValue) {
                console.log('marketing_card.is_auto_coupon');
                console.log(newValue);
                if (newValue) {
                    // this.changeStatus('marketing_card','mini_card_ele', this.$refs.mini_card_ele.innerHTML)
                    this.$nextTick(() => {
                        this.emitInnerHTML()   
                    })
                }
                // let that = this
                // that.marketing_card_setting = newValue 
            },
            deep: true,
            immediate: true
        },
        timeLineMode: {
            handler: function() {

            }
        }
    }
}
</script>

<style>
    .card-text-content p {
        margin: 0px;
    }
</style>

<style scoped>
    .card * {
	    overflow: hidden;
    }

    .card {
        display: flex;
        flex-direction: column;
        min-width: 375px;
    }

    .card-container {
        padding: 1em 0px;
        max-width: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
        height: 100%;
    }

    .card-container > .card  {
        max-width: 375px;
    }

    .card-content {
        display: flex;
        flex-direction: row;
        overflow: hidden;
        max-height: 100px;
    }
    
    .preview-card-container {
        display: flex;
        flex-direction: column;
    }

</style>